import { makeStyles, TableCell, TableRow, Tooltip } from "@material-ui/core";
import React from "react";
import clsx from "clsx";

import { FunctionDefinition } from "./types";

const useStyles = makeStyles({
  tableRow: {
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#f0f0f0",
    },
  },
  tableCell: {
    paddingTop: 6,
    paddingBottom: 6,
    lineHeight: "35px",
  },
  tableCellEllipsis: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  tableCellSource: {
    maxWidth: 150,
  },
  tableCellFunctionName: {
    maxWidth: 250,
  },
});

interface FunctionRowProps {
  onSelectFunction: () => void;
  functionDef: FunctionDefinition;
}

export const FunctionRow: React.FC<FunctionRowProps> = ({
  onSelectFunction,
  functionDef,
}) => {
  const classes = useStyles();

  return (
    <TableRow onClick={onSelectFunction} className={classes.tableRow}>
      <TableCell
        className={clsx(
          classes.tableCellFunctionName,
          classes.tableCellEllipsis,
          classes.tableCell
        )}
      >
        <Tooltip title={functionDef.name}>
          <span>{functionDef.name}</span>
        </Tooltip>
      </TableCell>
      <TableCell
        className={clsx(
          classes.tableCellSource,
          classes.tableCellEllipsis,
          classes.tableCell
        )}
      >
        {functionDef.source}
      </TableCell>
      <TableCell className={clsx(classes.tableCellEllipsis, classes.tableCell)}>
        {functionDef.type}
      </TableCell>
    </TableRow>
  );
};
